import MindPageLink from "../MindPageLink/MindPageLink";
import styles from "./MegaMenuCard.module.css";

function MegaMenuCard({ iconSrc, name, text, href, newTab, setShowMenu }) {
    function handleClick() {
        setShowMenu(false);
    }
    return (
        <MindPageLink
            className={styles.card}
            href={href}
            onClick={handleClick}
            target={newTab ? "_blank" : ""}
            // rel={newTab ? "noreferrer" : ""}
        >
            <img
                draggable={false}
                src={`/images/illustrations/${iconSrc}`}
                alt=""
            />
            <div className={styles.text}>
                <strong className={styles.name}>{name}</strong>
                <p className={styles.description}>{text}</p>
            </div>
        </MindPageLink>
    );
}

export default MegaMenuCard;
